import { render, staticRenderFns } from "./vue-telegram-login.vue?vue&type=template&id=3b0a7fb9&scoped=true"
import script from "./vue-telegram-login.vue?vue&type=script&lang=js"
export * from "./vue-telegram-login.vue?vue&type=script&lang=js"
import style0 from "./vue-telegram-login.vue?vue&type=style&index=0&id=3b0a7fb9&prod&scoped=true&lang=css"
import style1 from "./vue-telegram-login.vue?vue&type=style&index=1&id=3b0a7fb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a7fb9",
  null
  
)

export default component.exports